import { render, staticRenderFns } from "./WebsiteProfiles.vue?vue&type=template&id=d20e3436&scoped=true"
import script from "./WebsiteProfiles.vue?vue&type=script&lang=js"
export * from "./WebsiteProfiles.vue?vue&type=script&lang=js"
import style0 from "./WebsiteProfiles.vue?vue&type=style&index=0&id=d20e3436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20e3436",
  null
  
)

export default component.exports